import axios from 'axios'
import modulesDriversLoader from '../services/ModulesDriversLoader'

export default class InstituteManagementService {
    constructor() {
        modulesDriversLoader.load().then(({ getApiRoutes }) => {
            this.apiRotues = { ...getApiRoutes() }
        })
    }

    async fetchList(entityId, params = {}) {
        const response = await axios.get(
            `${this.apiRotues.API_BASE_URL}/entity_management/institute/legal_entity/${entityId}/list`,
            {
                params: params,
                headers: {
                    Authorization: `Bearer ${window.localStorage.getItem(
                        'LOCAL_STORAGE_KEY_ACCESS_TOKEN'
                    )}`
                }
            }
        )

        return response.data?.data || []
    }

    async create(payload = {}) {
        const response = await axios.post(
            `${this.apiRotues.API_BASE_URL}/entity_management/institute/add`,
            payload,
            {
                headers: {
                    Authorization: `Bearer ${window.localStorage.getItem(
                        'LOCAL_STORAGE_KEY_ACCESS_TOKEN'
                    )}`
                }
            }
        )

        return response.data?.data
    }

    async show(instituteId, params = {}) {
        const response = await axios.get(
            `${this.apiRotues.API_BASE_URL}/entity_management/institute/show/${instituteId}`,
            {
                params: params,
                headers: {
                    Authorization: `Bearer ${window.localStorage.getItem(
                        'LOCAL_STORAGE_KEY_ACCESS_TOKEN'
                    )}`
                }
            }
        )

        return response.data?.data || {}
    }

    async delete(instituteId) {
        const response = await axios.delete(
            `${this.apiRotues.API_BASE_URL}/entity_management/institute/remove/${instituteId}`,
            {
                headers: {
                    Authorization: `Bearer ${window.localStorage.getItem(
                        'LOCAL_STORAGE_KEY_ACCESS_TOKEN'
                    )}`
                }
            }
        )

        return response.data.data
    }

    async edit(instituteId, payload = {}) {
        const response = await axios.post(
            `${this.apiRotues.API_BASE_URL}/entity_management/institute/edit/${instituteId}`,
            payload,
            {
                headers: {
                    Authorization: `Bearer ${window.localStorage.getItem(
                        'LOCAL_STORAGE_KEY_ACCESS_TOKEN'
                    )}`
                }
            }
        )

        return response.data?.data
    }
}
